import React, {useEffect, useState} from 'react';
import {Grid} from '@mui/material';
import LocationFeatureListItem from './LocationFeatureListItem';

const LocationFeatureSortList = Object.freeze({
  "Manned Security": 0,
  "24/7 Access": 1,
  "Yard Cameras": 2,
  "Daily Inventory Report": 3,
  "Gate Cameras": 4,
  "Paved": 5,
  "Fenced / Gated": 6,
  "Lights": 7,
  "M & R Offered": 8,
  "Side-pick / Top-Pick": 9,
  "Overnight Truck Parking": 10,
  "Restrooms": 11
});

const SortLocationFeatures = (features) => {
  return features?.sort((a, b) => {
    return LocationFeatureSortList[a] - LocationFeatureSortList[b];
  });
}

const LocationFeatureList = (props) => {
  const {maxFeatures = 4, features} = props;
  const [topFeatures, setTopFeatures] = useState([]);

  useEffect(() => {
    if (features?.length > 0) {
      let sortedFeatures = SortLocationFeatures(features);
      if (sortedFeatures.length > maxFeatures) {
        setTopFeatures([...sortedFeatures.slice(0, maxFeatures)]);
      } else {
        setTopFeatures([...sortedFeatures]);
      }
    } else {
      setTopFeatures([]);
    }
  }, [features, maxFeatures]);

  return <Grid container direction={'column'} className={"ss-profile-feature-list"} spacing={0.7}>
    {
      topFeatures?.map(feature =>
        <LocationFeatureListItem key={feature} feature={feature} />
      )
    }
  </Grid>
}

export default LocationFeatureList;
